import React from 'react';
import Toggle from 'material-ui/Toggle';

export default props => (
  <Toggle
    {...props.inputProps}
    {...props.input}
    toggled={props.input.value ? true : false}
    onToggle={props.input.onChange}
  />
);



// WEBPACK FOOTER //
// src/modules/forms/components/ToggleField.js